/* eslint-disable react/require-default-props */
import React, { useCallback, useMemo, useState } from 'react';
import { Button } from '@ui/atoms/Button/Button';
import { SideDrawerContext } from './SideDrawerContext';
import './SideDrawerStyles.scss';
export function SideDrawer({ children, className = '', collapsible = false, defaultCollapsed = false }) {
    const [collapsed, setCollapsed] = useState(collapsible && defaultCollapsed);
    const toggleCollapsed = useCallback(() => {
        setCollapsed((prev) => !prev);
    }, []);
    const contextValue = useMemo(() => ({ collapsed, toggleCollapsed }), [collapsed, toggleCollapsed]);
    const drawerClasses = ['qmb-ui-side-drawer', collapsed ? 'qmb-ui-side-drawer--collapsed' : '', className]
        .filter(Boolean)
        .join(' ');
    return (React.createElement(SideDrawerContext.Provider, { value: contextValue },
        React.createElement("aside", { className: drawerClasses, "aria-label": "Side drawer" },
            collapsible && (React.createElement("div", { className: "qmb-ui-side-drawer__toggle-container" },
                React.createElement(Button, { className: "qmb-ui-side-drawer__toggle", onClick: toggleCollapsed, "aria-label": collapsed ? 'Expand sidebar' : 'Collapse sidebar', title: collapsed ? 'Expand sidebar' : 'Collapse sidebar' },
                    React.createElement("i", { className: "fa-light fa-sidebar" })))),
            children)));
}
